import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M639.999 209.777H756.018L621.665 75.4247L697.09 0L960.201 263.111L700.005 523.307L624.58 447.883L756.019 316.444H639.999C463.268 316.444 319.999 459.713 319.999 636.444H213.332C213.332 400.802 404.357 209.777 639.999 209.777Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M639.999 853.333C639.999 735.513 735.511 640 853.332 640H1706.67C1824.49 640 1920 735.513 1920 853.333V1706.67C1920 1824.49 1824.49 1920 1706.67 1920H853.332C735.511 1920 639.999 1824.49 639.999 1706.67V853.333ZM853.332 746.667H1706.67C1765.58 746.667 1813.33 794.423 1813.33 853.333V1706.67C1813.33 1765.58 1765.58 1813.33 1706.67 1813.33H853.332C794.422 1813.33 746.665 1765.58 746.665 1706.67V853.333C746.665 794.423 794.422 746.667 853.332 746.667Z",
  fillRule: "evenodd"
}));

var IconRotateRightLine = /*#__PURE__*/function (_Component) {
  _inherits(IconRotateRightLine, _Component);

  var _super = _createSuper(IconRotateRightLine);

  function IconRotateRightLine() {
    _classCallCheck(this, IconRotateRightLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconRotateRightLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRotateRight",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRotateRightLine.displayName = "IconRotateRightLine";
  return IconRotateRightLine;
}(Component);

IconRotateRightLine.glyphName = 'rotate-right';
IconRotateRightLine.variant = 'Line';
IconRotateRightLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRotateRightLine;
export { IconRotateRightLine };